package top.wcpe.allincore.dsl.compiler.semantic.`native`.methods

import top.wcpe.allincore.dsl.compiler.ast.ExprAst
import top.wcpe.allincore.dsl.compiler.diag.DiagnosticCollector
import top.wcpe.allincore.dsl.compiler.semantic.`native`.Arity
import top.wcpe.allincore.dsl.compiler.semantic.`native`.MethodDescriptor
import top.wcpe.allincore.dsl.compiler.semantic.`native`.ResolveCtx

/**
 * 内置 object {@code persist} 的方法占位描述符集合。
 *
 * <p>persist.x 字段读写不走 MemberCall（编译期被识别为 PersistRef / PersistAssign）。
 * 仅命令式方法 persist.save() / persist.reload() 通过本表登记。</p>
 */

/** persist.save()。 */
object PersistSaveMethod : MethodDescriptor {
    override val name: String = "save"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

/** persist.reload()。 */
object PersistReloadMethod : MethodDescriptor {
    override val name: String = "reload"
    override val arity: Arity = Arity.Fixed(0)
    override fun resolve(call: ExprAst.MemberCall, diag: DiagnosticCollector, ctx: ResolveCtx): ExprAst? = null
}

val PersistApiMethodMap: Map<String, MethodDescriptor> = listOf(
    PersistSaveMethod,
    PersistReloadMethod,
).associateBy { it.name }
